import React, { Component } from 'react';
// import { withStyles } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';

class BudgetChangeConfirmationDialog extends Component {

    handleCancel = (event) => {
      if (this.props.onCancel) {
        this.props.onCancel(event);
      }
      this.props.onClose(event);
    };

    handleContinue = (event) => {
      if (this.props.onCancel) {
        this.props.onContinue(event);
      }
      this.props.onClose(event);

    };

    handleBuySubscription = (event) => {
      if (this.props.onBuySubscription) {
        this.props.onBuySubscription(event);
      }
      this.props.onClose(event);
    };

    render() {
  
      return (
          <Dialog
            
            disableEscapeKeyDown
            open={this.props.open}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.props.onClose()
              }
            }}
            maxWidth="xs"
          >
          <DialogTitle id="confirmation-dialog-title">{'Customer is not set for using budgets'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography>This customer is not set for using budgets.  If you proceed, the customer will be set for using budgets</Typography>
            </DialogContentText>
          </DialogContent>

            <DialogActions>
             <Button onClick={this.handleCancel} color="primary" variant="outlined">
                {'Cancel'}
              </Button>
              <Button onClick={this.handleBuySubscription} color="primary" variant="outlined">
                { ' Go to buy subscription ' }
              </Button>
              <Button onClick={this.handleContinue} color="primary" variant="contained">
                { 'Turn budgets On ' }
              </Button>
             </DialogActions>
        </Dialog>
      );
    }
}
  
export default BudgetChangeConfirmationDialog;
// export default withStyles(styleSheet)(BackButton);